import type { ComponentProps } from "react"

export default function MaskOutside(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "hsl(var(--foreground))", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <g clipPath="url(#clip0_2767_91)">
        <path
          d="M7.687 0L0 7.687V6.273L6.273 0H7.687ZM3.273 0L0 3.273V4.687L4.687 0H3.273ZM0.273 0L0 0.273V1.687L1.687 0H0.273ZM12.733 16L16 12.732V11.318L11.318 16H12.733ZM16 0.687L11.43 5.257L12.546 5.747L16 2.293V3.707L13.038 6.669L12.799 8.494L16 5.293V6.707L12.587 10.12L12.355 11.901L16 8.256V9.67L9.67 16H8.256L11.256 13H9.707L6.707 16H5.293L8.293 13H6.707L3.707 16H2.293L5.293 13H3.687L0.687 16H0V15.273L3.143 12.13L2.97 10.717L0 13.687V12.273L2.815 9.458L2.641 8.046L0 10.687V9.273L9.273 0H10.687L7.257 3.43L8.36 3.913L12.273 0H13.687L9.343 4.344L10.446 4.827L15.273 0H16V0.687ZM6.478 4.181L3.538 7.146L4.135 12H11.333L12.036 6.615L6.478 4.181ZM15.695 16L16 15.695V14.28L14.28 16H15.695Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2767_91">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
